import { PublicLegalLinks } from './components/ProductNotice';
import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PublicBillView from './PublicBillView';
import SettleUpView from './SettleUpView';
import reportWebVitals from './reportWebVitals';

// Include the capability on legacy-shaped reads as well as V2 payment calls.
axios.defaults.headers.common['X-Vibesplit-Capabilities'] = 'payments-v2';

// Check if we're on a public bill view route (/b/:shareId)
const isPublicBillView = window.location.pathname.startsWith('/b/');
// Check if we're on a public trip view route (/t/:shareId)
const isPublicTripView = window.location.pathname.startsWith('/t/');
// Check if we're on a settle up view route (/s/:code)
const isSettleUpView = window.location.pathname.startsWith('/s/');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {isPublicBillView ? (
      <PublicBillView />
    ) : isPublicTripView ? (
      <main className="vs-design" style={{ maxWidth: 440, margin: '80px auto', padding: 24 }}><h1>Trips is no longer available</h1><p>Your individual bills are still available.</p><a href="/app/">Open your bills</a></main>
    ) : isSettleUpView ? (
      <SettleUpView />
    ) : (
      <App />
    )}
    {(isPublicBillView || isPublicTripView || isSettleUpView) && <footer className="vs-design product-public-footer"><PublicLegalLinks /></footer>}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
